export const REVOKED_ACCOUNT_MESSAGE =
  "User account has been revoked";

export const isAccountRevokedError = (err) => {
  const message = (
    err?.response?.data?.message ||
    err?.message ||
    err?.revokedMessage ||
    ""
  ).toLowerCase();
  const status = err?.response?.status;
  return (
    err?.revoked === true ||
    (status === 403 && message.includes("revoked")) ||
    message.includes("account has been revoked")
  );
};

export const getAuthErrorMessage = (err) =>
  err?.response?.data?.message ||
  err?.message ||
  err?.revokedMessage ||
  REVOKED_ACCOUNT_MESSAGE;
